import { injectable, inject } from 'inversify';
import IUserIdStorage from './IUserIdStorage';
import ThirdPartyTypes from '../../di/ThirdPartyTypes';

const ATTO_USER_ID = 'atto.userId';

// Context
// When users have the AISP false, token is not returned when users redirect back to Connect and due to that the consent summary endpoint isn't called which returns the userId.
// hence we lack the userId required to group consents appropriately, resulting in a creating a new user on addAnotherAccount in Connect and showing incorrectly on the dashboard.
// in order to fix it userId was removed from local client state and added in session storage.

@injectable()
export default class UserIdStorage implements IUserIdStorage {
  @inject(ThirdPartyTypes.LocalStorage)
  private localStorage!: Storage;

  getClientId() {
    const urlParams = new URLSearchParams(window.location.search);
    const clientId = urlParams.get('client_id');
    return clientId;
  }

  setUserId(userId: string): void {
    const clientId = this.getClientId();
    this.localStorage.setItem(`${ATTO_USER_ID}.${clientId}`, userId);
  }

  hasUserId(): boolean {
    const clientId = this.getClientId();
    return null !== this.localStorage.getItem(`${ATTO_USER_ID}.${clientId}`);
  }

  getUserId(): string | null {
    const clientId = this.getClientId();
    return this.localStorage.getItem(`${ATTO_USER_ID}.${clientId}`);
  }
}
